import { render } from "./TopBar.vue?vue&type=template&id=ff01fbf8&scoped=true"
import script from "./TopBar.vue?vue&type=script&js=true&lang=js"
export * from "./TopBar.vue?vue&type=script&js=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=ff01fbf8&scoped=true&lang=css"
import "./TopBar.vue?vue&type=style&index=1&id=ff01fbf8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff01fbf8"]])

export default __exports__